import {
    Pencil,
    Trash2,
    Loader2,
} from "lucide-react";
import getImageUrl from "../../../utils/imageUrl";
import "./CategoryTable.css";

function CategoryTable({
    categories,
    loading,
    onEdit,
    onDelete,
    reload,
}) {

    const handleDelete = async (id) => {

        const confirmDelete = window.confirm(
            "Are you sure you want to delete this category?"
        );

        if (!confirmDelete) return;

        try {

            await onDelete(id);

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to delete category.");

        }

    };

    if (loading) {

        return (

            <div className="category-loading">

                <Loader2
                    size={40}
                    className="spin"
                />

                <p>Loading Categories...</p>

            </div>

        );

    }

    if (categories.length === 0) {

        return (

            <div className="category-empty">

                <h3>No Categories Found</h3>

                <p>
                    Create your first category.
                </p>

            </div>

        );

    }

    return (

        <div className="category-table-wrapper">

            <table className="category-table">

                <thead>

                    <tr>

                        <th>Image</th>

                        <th>Name</th>

                        <th>Slug</th>

                        <th>Color</th>

                        <th>Foods</th>

                        <th>Orders</th>

                        <th>Featured</th>

                        <th>Popular</th>

                        <th>Status</th>

                        <th>Sort</th>

                        <th>Actions</th>

                    </tr>

                </thead>

                <tbody>

                    {categories.map((category) => (

                        <tr key={category._id}>

                            <td>

                                {category.image ? (

                                  <img
    src={getImageUrl(category.image)}
    alt={category.name}
    className="category-image"
    onError={(e) => {
        e.currentTarget.style.display = "none";
    }}
/>
                                ) : (

                                    <div className="image-placeholder">

                                        📂

                                    </div>

                                )}

                            </td>

                            <td>

                                <div className="category-name">

                                    <strong>

                                        {category.name}

                                    </strong>

                                </div>

                            </td>

                            <td>

                                {category.slug || "-"}

                            </td>

                            <td>

                                <div
                                    className="color-box"
                                    style={{
                                        background:
                                            category.color,
                                    }}
                                />

                            </td>

                            <td>

                                {category.totalFoods}

                            </td>

                            <td>

                                {category.totalOrders}

                            </td>

                            <td>

                                <span
                                    className={
                                        category.isFeatured
                                            ? "badge success"
                                            : "badge gray"
                                    }
                                >

                                    {category.isFeatured
                                        ? "Yes"
                                        : "No"}

                                </span>

                            </td>

                            <td>

                                <span
                                    className={
                                        category.isPopular
                                            ? "badge warning"
                                            : "badge gray"
                                    }
                                >

                                    {category.isPopular
                                        ? "Yes"
                                        : "No"}

                                </span>

                            </td>

                            <td>

                                <span
                                    className={
                                        category.isActive
                                            ? "badge active"
                                            : "badge inactive"
                                    }
                                >

                                    {category.isActive
                                        ? "Active"
                                        : "Inactive"}

                                </span>

                            </td>

                            <td>

                                {category.sortOrder}

                            </td>

                            <td>

                                <div className="table-actions">

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            onEdit(category)
                                        }
                                    >

                                        <Pencil size={16} />

                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(
                                                category._id
                                            )
                                        }
                                    >

                                        <Trash2 size={16} />

                                    </button>

                                </div>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

}

export default CategoryTable;